export default {"src":"/_next/static/media/gericon.4934a56b.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};